module.exports = __webpack_public_path__ + "img/sin-promo.10068ec4.png";